import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  useLocation
} from "react-router-dom";
import { MemberResetPassword } from "../../Auth/screens/MemberResetPassword";
import { useMutationCreateSession } from "../../query/users/mutations";
import { OverlaySpinner } from "../OverlaySpinner";
import { MemberSignIn } from "../../Auth/screens/MemberSignIn";
import { AuthSSO } from "../../Auth/screens/AuthSSO";
import {
  INVITATION_AUTH_PATH,
  InvitationAuthIndex
} from "../../modules/Invitations";
import { PATH_V3_PERSONS_INVITATION } from "../../modules/Invitations/paths";
import {
  REQUEST_INVITATION_USER_LINK_PATH,
  RouteRequestLinkIndex
} from "../../modules/Invitations/routes/RouteRequestLink/RouteRequestLinkIndex";

type RouteProps = RouteComponentProps<{ invoiceId: string }>;

type Props = RouteProps;

const RequestGuestSession: React.FC<Props> = () => {
  const [signInAsGuest] = useMutationCreateSession();

  useEffect(() => {
    signInAsGuest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <OverlaySpinner />;
};

export const AuthApp: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <Switch>
      {/* Invite is the only way to sign up */}
      <Route
        path={REQUEST_INVITATION_USER_LINK_PATH}
        component={RouteRequestLinkIndex}
      />
      <Route
        path={PATH_V3_PERSONS_INVITATION}
        component={InvitationAuthIndex}
      />
      <Route path={INVITATION_AUTH_PATH} component={InvitationAuthIndex} />
      <Redirect from="/register" to="/member/sign-in" />
      <Redirect from="/sign-up" to="/member/sign-in" />

      <Route path="/member/reset-password" component={MemberResetPassword} />
      <Route path="/payment" component={RequestGuestSession} />

      <Redirect path="/invoice-payment/:invoiceId" to="/payment/:invoiceId" />

      <Redirect path="/i/:invoiceId" to="/payment/:invoiceId" />
      {!!params.get("growth_name") ? null : (
        <Redirect path="/p/:invoiceId" to="/payment/:invoiceId" />
      )}

      <Redirect path="/pay/:tag" to="/payment/ppl/:tag" />
      <Redirect path="/ppl/:tag" to="/payment/ppl/:tag" />

      {/* All sign in routes */}
      <Route path="/member/sign-in" component={MemberSignIn} />
      <Route path="/auth/login" component={MemberSignIn} />
      <Route path="/auth/sso" component={AuthSSO} />
      <Redirect from="/sign-in" to="/member/sign-in" />
      <Route
        path="*"
        render={({ location }) => (
          <Redirect
            to={`/member/sign-in#${location.pathname}${location.search}`}
          />
        )}
      />
    </Switch>
  );
};
